<template>
  <section class="user-evaluations" fluid>
    <v-layout class="section-box" row wrap align-center>
      <v-flex xs12 md6>
        <span class="my-2 mx-4">
          Última avaliação:
          <strong v-if="lastEvaluation">
            {{ lastEvaluation.updated_at |  moment('DD/MM/Y, HH:mm') }}
          </strong>
          <strong v-else>Não realizada</strong>
        </span>
      </v-flex>
      <v-flex xs12 md6 class="text-xs-right">
        <v-btn round depressed large color="deep-orange darken-2" dark
          v-modal-trigger="'showNewNotification'" :data-item="JSON.stringify(newNotificationData)">
          Notificar aluno
          <v-icon small right>fal fa-bell</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <br>
    <evaluations-list :user="user" :evaluations="evaluations"></evaluations-list>
    <health-card v-if="healthCard" :healthCard="healthCard"></health-card>
    <photo-grid :user="user"></photo-grid>
  </section>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'
import AdminUserShowEvaluationList from '@/components/admin/evaluations/AdminUserShowEvaluationList'
import UserHealthCard from '@/components/user/evaluations/UserHealthCard'
import AdminPhotoGrid from '@/components/admin/evaluations/AdminPhotoGrid'

export default {
  name: 'AdminUserShowEvaluations',

  data: () => ({
    loadingRequest: false,
    evaluations: [],
    lastEvaluation: {},
    healthCard: null
  }),

  methods: {
    loadHealthCard () {
      // eslint-disable-next-line
      let path = `${API.userHealthyCards}/users/${this.$route.params.id}`

      axios.get(path).then(response => {
        if (response.data.healthy_card) { this.healthCard = response.data.healthy_card }
        this.loadEvaluations()
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar o questionário de saúde',
          color: 'error'
        })
      })
    },

    loadEvaluations () {
      // eslint-disable-next-line
      let path = `${API.userEvaluations}/users/${this.$route.params.id}`

      axios.get(path).then(response => {
        if (response.data.evaluations) {
          this.evaluations = response.data.evaluations
          this.lastEvaluation = this.evaluations[0]
        }
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as avaliações',
          color: 'error'
        })
      })
    }
  },

  components: {
    'evaluations-list': AdminUserShowEvaluationList,
    'photo-grid': AdminPhotoGrid,
    'health-card': UserHealthCard
  },

  beforeDestroy () {
    EventBus.$off('loadUserEvaluations')
  },

  created () {
    EventBus.$on('loadUserEvaluations', this.loadHealthCard)
    this.loadHealthCard()
  },

  computed: {
    newNotificationData () {
      return {
        user: this.user._id,
        all_users: false,
        title: 'Você tem uma avaliação pendente!',
        // eslint-disable-next-line
        url: `${API.siteURL}/evaluations`
      }
    }
  },

  props: ['user']
}
</script>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowEvaluations.vue